import { Headline } from "@App/Components/atoms/common/Headline";
import { CheckIcon } from "@App/Components/common/Icons";
import { Fragment, type FunctionComponent } from "react";
import { Trans, useTranslation } from "react-i18next";

export const ReturnSummary: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <div
        className={
          "container md:w-[600px] m-5 h-[calc(100vh-150px)] flex items-start md:items-center mx-auto"
        }
      >
        <div>
          <CheckIcon
            className={"w-14 h-14 border-2 border-primary rounded-full p-3 mb-3"}
            primary
          />
          <Headline type="h1">{t("vehicleReturn.summary-headline")}</Headline>
          <p className={"text-neutral-500 mb-3"}>{t("vehicleReturn.summary-text-1")}</p>
          <p className={"text-neutral-500"}>
            <Trans
              components={{
                a: <a href={"mailto:abholung@santander.de"} />,
              }}
              i18nKey="vehicleReturn.summary-text-2"
            />
          </p>
        </div>
      </div>
    </Fragment>
  );
};
